import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";


export function useVideoPoker() {
  const [config, setConfig] = useState(null);
  const [round, setRound] = useState(null);
  const [discarded, setDiscarded] = useState([]);
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState([]);
  const [phase, setPhase] = useState("ready");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const [stateResponse, historyResponse] = await Promise.all([api.get("/games/poker/state"), api.get("/games/poker/history")]);
      setConfig(stateResponse.data);
      setRound(stateResponse.data.active_round);
      setPhase(stateResponse.data.active_round ? "select" : "ready");
      setHistory(historyResponse.data || []);
    } catch (requestError) { setError(errMsg(requestError)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  async function deal() {
    if (busy || round?.status === "dealt") return;
    setBusy(true); setError(""); setResult(null); setDiscarded([]); setPhase("dealing");
    try {
      const response = await api.post("/games/poker/deal", { deal_id: crypto.randomUUID() });
      setRound(response.data); setPhase("select");
      setConfig((current) => ({ ...current, balance: response.data.balance }));
    } catch (requestError) { setError(errMsg(requestError)); setPhase("ready"); }
    finally { setBusy(false); }
  }

  function toggleDiscard(index) {
    if (busy || round?.status !== "dealt") return;
    setDiscarded((current) => current.includes(index) ? current.filter((item) => item !== index) : [...current, index].sort());
  }

  async function draw() {
    if (busy || round?.status !== "dealt") return;
    const heldIndices = [0, 1, 2, 3, 4].filter((index) => !discarded.includes(index));
    setBusy(true); setError(""); setPhase("drawing");
    try {
      const response = await api.post("/games/poker/draw", { round_id: round.round_id, held_indices: heldIndices });
      await new Promise((resolve) => window.setTimeout(resolve, 650));
      setRound(response.data); setResult(response.data); setPhase("showdown");
      setConfig((current) => ({ ...current, balance: response.data.balance }));
      const historyResponse = await api.get("/games/poker/history");
      setHistory(historyResponse.data || []);
    } catch (requestError) { setError(errMsg(requestError)); setPhase("select"); }
    finally { setBusy(false); }
  }

  return { config, round, discarded, result, history, phase, busy, error, deal, draw, toggleDiscard };
}